import { render, staticRenderFns } from "./CompanyPreviewDetail.vue?vue&type=template&id=2f489c32&scoped=true"
import script from "./CompanyPreviewDetail.vue?vue&type=script&lang=js"
export * from "./CompanyPreviewDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyPreviewDetail.vue?vue&type=style&index=0&id=2f489c32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f489c32",
  null
  
)

export default component.exports